import { useFieldArray } from '@graphcommerce/ecommerce-ui'
import { CustomizableFieldOption, EnteredOptionInput } from '@graphcommerce/graphql-mesh'
import { useFormGqlMutationCart } from '@graphcommerce/magento-cart'
import { OrderItemFragment } from '@graphcommerce/magento-customer/components/OrderItem/OrderItem.gql'
import { ProductCustomizableFragment } from '@graphcommerce/magento-product/components/ProductCustomizable/ProductCustomizable.gql'
import { ConfigurableProductAddToCartDocument } from '@graphcommerce/magento-product-configurable/graphql/ConfigurableProductAddToCart.gql'
import { i18n } from '@lingui/core'
import { Trans } from '@lingui/react'
import { useMemo } from 'react'
import { Button } from '../../Button'
import { ProductCustomizable } from '../../Product/ProductCustomizable/ProductCustomizable'
import { OrderItemAdditionalFragment } from '../OrderItem/OrderItemAdditional.gql'

type ReorderItemAdjustmentsProps = OrderItemFragment &
  OrderItemAdditionalFragment & {
    setAdjustedOptions: (values: EnteredOptionInput[]) => void
  } & {
    product: ProductCustomizableFragment
  }

export function ReorderItemOptions(props: ReorderItemAdjustmentsProps) {
  const { product_sku, setAdjustedOptions, selected_options, product } = props

  const form = useFormGqlMutationCart(ConfigurableProductAddToCartDocument, {
    defaultValues: { quantity: 1, sku: product_sku, enteredOptions: [] },
    onBeforeSubmit: ({ enteredOptions, ...vars }) => {
      if (enteredOptions) {
        setAdjustedOptions([...(enteredOptions as EnteredOptionInput[])])
      }
      return false
    },
  })

  const { handleSubmit, control } = form
  const submitHandler = handleSubmit(() => {})

  useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: 'enteredOptions', // unique name for your Field Array
  })

  const notSelectedOptions = useMemo(() => {
    if (product) {
      const alreadySelectedOptionLabels = selected_options?.map((o) => o?.label)
      return product.options?.filter(
        (option) =>
          option?.title &&
          !alreadySelectedOptionLabels?.includes(option?.title) &&
          (option.__typename !== 'CustomizableFieldOption' ||
            (option as CustomizableFieldOption).simples?.includes(product_sku)),
      )
    }
    return []
  }, [product, selected_options, product_sku])

  return (
    <div className='flex min-h-[400px] w-full items-center justify-center p-[20px] md:min-w-[400px]'>
      <div>
        <form onSubmit={submitHandler} noValidate>
          <h3>
            <Trans id='This item has new options included, please make your selection below.' />
          </h3>
          <ProductCustomizable
            product={{ ...product, options: notSelectedOptions }}
            form={form}
            selectedVariantSku={product_sku}
          />
          <Button
            type='submit'
            color='gold'
            label={i18n._('Select Options')}
            className='Type-Base-Medium w-full py-1'
          />
        </form>
      </div>
    </div>
  )
}
